import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Heading,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import * as PropTypes from 'prop-types';

/**
 *
 * @param {Array}input
 * @param {function}calculatorPaymentFees
 * @param {Array} shopifyPlanPricing
 * @return {JSX.Element}
 * @constructor
 */
export default function ShopifyPricingTable({
  input,
  calculatorPaymentFees,
  shopifyPlanPricing,
}) {
  return (
    <HStack wrap={'wrap'}>
      {shopifyPlanPricing.map((plan, index) => {
        const fees = calculatorPaymentFees({
          input,
          price: input.isPlanYearly ? plan.priceYearly : plan.priceMonthly,
          isGateWayShopify: input.typePaymentGateway === 'shopify',
          shopifyPaymentPlan: plan,
        });

        if (!input.isShowShopifyPlus && index === shopifyPlanPricing.length - 1)
          return;

        return (
          <>
            {index === 0 && (
              <Card
                minW="250"
                maxW="250"
                align={'flex-start'}
                variant={'outline'}
                style={{ border: 'none' }}
                mt={5}
                marginX={1}
              >
                <CardHeader style={{ paddingBottom: 0 }}>{''}</CardHeader>
                <CardBody>
                  <VStack align={'flex-start'}>
                    <Text fontSize={'3xl'}>Total Cost</Text>
                    <Text pt={'1rem'}>Plan fee</Text>
                    <Text>External payment fees</Text>
                    <Text>Shopify payment fee</Text>
                    <Text>Transaction fee</Text>
                    <Text pt={10}>{''}</Text>
                  </VStack>
                </CardBody>
              </Card>
            )}
            <Card
              minW="250"
              maxW="250"
              justify={'center'}
              variant={'filled'}
              style={{ marginTop: '0.5rem' }}
            >
              <CardHeader style={{ paddingBottom: 0 }}>
                <Heading style={{ color: '#407bff' }} size="md">
                  {plan.name}
                </Heading>
              </CardHeader>
              <CardBody>
                <VStack align={'center'}>
                  <Text fontSize={'3xl'}>$ {fees.totalCost.toFixed(2)}</Text>
                  <Text pt={'1rem'}>
                    ${' '}
                    {input.isPlanYearly ? plan.priceYearly : plan.priceMonthly}
                  </Text>
                  <HStack>
                    <Text
                      color={
                        input.typePaymentGateway === 'shopify' ? 'gray' : ''
                      }
                    >
                      ${' '}
                      {input.typePaymentGateway !== 'shopify'
                        ? fees.creditCardRate.toFixed(2)
                        : 0}
                    </Text>
                    <Text fontSize={'sm'}>
                      {input.typePaymentGateway !== 'shopify' &&
                        `(${input.externalPaymentPercent}% + ${input.externalPaymentMoney}$)`}
                    </Text>
                  </HStack>

                  <HStack>
                    <Text
                      color={
                        input.typePaymentGateway !== 'shopify' ? 'gray' : ''
                      }
                    >
                      ${' '}
                      {input.typePaymentGateway === 'shopify'
                        ? fees.creditCardRate.toFixed(2)
                        : 0}
                    </Text>
                    <Text fontSize={'sm'}>
                      {input.typePaymentGateway === 'shopify' &&
                        `(${(plan.shopifyPaymentRate * 100).toFixed(
                          1
                        )}% + 0.3$)`}
                    </Text>
                  </HStack>

                  <HStack>
                    <Text color={fees.transactionFees === 0 ? 'gray' : ''}>
                      {fees.transactionFees === 0
                        ? 'None'
                        : `$ ${fees.transactionFees.toFixed(2)}`}
                    </Text>
                    {fees.transactionFees !== 0 && (
                      <Text fontSize={'sm'}>
                        ({plan.transactionFee * 100}%)
                      </Text>
                    )}
                  </HStack>
                  <Button
                    color="#ffffff"
                    backgroundColor={'#407bff'}
                    colorScheme="blue"
                    style={{ borderRadius: '2rem' }}
                    onClick={() => {
                      window.open(plan.url);
                    }}
                  >
                    {'Start now'}
                  </Button>
                </VStack>
              </CardBody>
            </Card>
          </>
        );
      })}
    </HStack>
  );
}

ShopifyPricingTable.propTypes = {
  input: PropTypes.shape({
    orderPerMonth: PropTypes.number,
    typePaymentGateway: PropTypes.string,
    isPlanYearly: PropTypes.bool,
    avgOrderValue: PropTypes.number,
    isShowShopifyPlus: PropTypes.bool,
    externalPaymentPercent: PropTypes.number,
    externalPaymentMoney: PropTypes.number,
  }),
  calculatorPaymentFees: PropTypes.func,
  shopifyPlanPricing: PropTypes.array,
};
